module.exports = __webpack_public_path__ + "static/media/A12.582cef86.png";